import { Check, ChevronDown, ChevronUp, Pencil, X } from "lucide-react";
import { useState } from "react";
import NumberInput from "./NumberInput";

interface RewardAmountEditorProps {
  label: string;
  symbol: string;
  value: number;
  onChange: (value: number) => void;
}

export default function RewardAmountEditor({
  label,
  symbol,
  value,
  onChange,
}: RewardAmountEditorProps) {
  const [editing, setEditing] = useState(false);
  const [draftValue, setDraftValue] = useState(String(value));

  if (!editing) {
    return (
      <div>
        <p className="text-[13px] text-[#758089]">{label}</p>
        <button
          type="button"
          onClick={() => {
            setDraftValue(String(value));
            setEditing(true);
          }}
          className="mt-[4px] inline-flex items-center gap-[6px] text-[16px] font-bold text-[#1E1E1E]"
        >
          {symbol}
          {value}
          <Pencil className="size-[14px] text-[#A1A1AA]" />
        </button>
      </div>
    );
  }

  return (
    <div>
      <p className="text-[13px] text-[#758089]">{label}</p>
      <div className="mt-[4px] inline-flex items-center gap-[6px]">
        <span className="flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border border-[#E4E4E7] bg-[#F9FAFB] text-[14px] text-[#3F3F46]">
          {symbol}
        </span>
        <div className="relative">
          <NumberInput
            thousandSeparator
            value={draftValue}
            onChange={(e) => setDraftValue(e.target.value)}
            className="h-[32px] w-[90px] rounded-[6px] border border-[#E4E4E7] pl-[10px] pr-[20px] text-[14px] text-[#1E1E1E] outline-none"
          />
          <div className="absolute right-[4px] top-1/2 flex -translate-y-1/2 flex-col">
            <button
              type="button"
              onClick={() => setDraftValue((v) => String((Number(v) || 0) + 1))}
              className="text-[#A1A1AA]"
            >
              <ChevronUp className="size-[10px]" />
            </button>
            <button
              type="button"
              onClick={() =>
                setDraftValue((v) => String(Math.max(0, (Number(v) || 0) - 1)))
              }
              className="text-[#A1A1AA]"
            >
              <ChevronDown className="size-[10px]" />
            </button>
          </div>
        </div>
        <button
          type="button"
          onClick={() => {
            onChange(Number(draftValue) || 0);
            setEditing(false);
          }}
          className="flex size-[32px] items-center justify-center rounded-[6px] border border-[#16A34A] text-[#16A34A]"
        >
          <Check className="size-[14px]" />
        </button>
        <button
          type="button"
          onClick={() => setEditing(false)}
          className="flex size-[32px] items-center justify-center rounded-[6px] border border-[#E4E4E7] text-[#A1A1AA]"
        >
          <X className="size-[14px]" />
        </button>
      </div>
    </div>
  );
}
